<template class="${slideIn} background-split-${backgroundSplit}"
          sneak
          sneak-class="sneak-in"
          sneak-offset="300">

  <require from="./flutscher.css"></require>

  <div class="bkgrnd-top"></div>
  <div class="bkgrnd-bottom"></div>

  <div class="slide">

    <div class="container_fluid ">

      <div class="container">

        <div class="background">
          <img src="/assets/images/flutscher/yello.png" style.bind="widthString" alt="" ref="roundedImage">
          <div class="ext"></div>
        </div>

        <slot name="outter-top"></slot>

        <div class="container_inner_narrow">
          <slot name="inner"></slot>
        </div>

        <div>
          <slot name="outter-bottom"></slot>
        </div>

      </div>

    </div>
  </div>
</template>
